import { createSelector } from 'reselect';
import { ICategoryState, IRootSubCategoryName } from './types';

export const selectCategoryLoadedState = (state: ICategoryState) => state.categoryLoaded;
export const selectRootCategories = (state: ICategoryState) => state.rootCategories;

export const selectRootSubCategories = (state: ICategoryState, root: IRootSubCategoryName) =>
  state.rootSubCategories[root];
export const selectRootSubCategoriesLoaded = (state: ICategoryState, root: IRootSubCategoryName) =>
  state.loadedSubCategories[root];
export const selectRootSubCategoriesSyncing = (state: ICategoryState, root: IRootSubCategoryName) =>
  state.syncingSubCategories[root];

export const selectRootSubCategoriesError = (state: ICategoryState, root: IRootSubCategoryName) =>
  state.errorSubCategories[root];

export const selectSyncError = (state: ICategoryState) => state.error;
export const selectSyncState = (state: ICategoryState) => state.syncing;

export const selectIndexedAncestors = (state: ICategoryState) => state.ancestors;

export const selectNodeAncestors = createSelector(
  [selectIndexedAncestors, (_: any, id: any) => id],
  (indexedAncestors, id) => indexedAncestors[id]
);
